<template>
  <div class="container videos">
    <div class="columns is-multiline" v-if="videos.length > 0">

      <video-item v-for="video in videos" :key="video.id"
      :item="video"></video-item>
    </div>
  </div>

</template>

<script>
import VideoItem from "@/components/VideoItem.vue";

export default {
  name: `Videos`,
  components: {
    VideoItem,
  },
  props: {
    videos: Array
  },
};
</script>

<style lang="scss">
.videos {
  max-width: 1344px;
  padding-top: 30px;
  margin-top: 10px;
}
.columns {
  max-width: 100%;
}
</style>
